<template>
    <div class="card h-100 shadow-sm">
        <div class="card-body p-2">
            <div class="row no-gutters">
                <div class="col-xl-12 col-lg-6 py-2">
                    <div class="card border-0 h-100">
                        <div class="card-body p-1 text-center">
                            <div class="text-uppercase"><i class="lnr lnr-rocket"></i> Activity</div>
                            <div class="py-2">
                                <BarChart height="160" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-12 col-lg-6 pt-2">
                    <div class="card border-0 h-100">
                        <div class="card-body p-1 text-center">
                            <div class="text-uppercase"><i class="lnr lnr-leaf"></i> Nodes</div>
                            <div class="py-2">
                                <BarChart height="160" :data="dataBar2"></BarChart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BarChart from '../components/Charts/BarChart';

export default {
    components: {
        BarChart
    },
    data() {
        return {
            dataBar2: {
              "labels": [
                "S",
                "M",
                "T",
                "W",
                "T",
                "F",
                "S"
              ],
              "datasets": [
                {
                "label": "Dip",
                "data": [
                    489,
                    245,
                    300,
                    203,
                    339,
                    102,
                    234
                  ]
                },
                {
                "label": "Dap",
                "data": [
                    209,
                    245,
                    283,
                    403,
                    589,
                    692,
                    580
                  ]
                },
                {
                "label": "Dup",
                "data": [
                    289,
                    435,
                    323,
                    190,
                    289,
                    103,
                    200
                  ]
                },
                {
                "label": "Dop",
                "data": [
                    139,
                    415,
                    593,
                    378,
                    209,
                    432,
                    374
                  ]
                }]
            }
        }
    }
}
</script>
